import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { TableData } from "../../../../core/data/interface";
import { all_routes } from "../../../router/all_routes";
// import ImageWithBasePath from "../../../../core/common/imageWithBasePath"
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import Table from "../../../../core/common/dataTable/index";
import MultiSelectSection from "../../../../core/common/multiSelect";
import {
  // allClass,
  // allSection,
  gender,
  REGISTRATION_SORT_OPTIONS,
  // names,
  status,
} from "../../../../core/common/selectoption/selectoption";
import TooltipOption from "../../../../core/common/tooltipOption"; // Import your API client
import { getAllRegistration } from "../../../../service/registration";
import RegistrationModals from "../registrationModals";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { Class, getAllClasses } from "../../../../service/classes";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { formatDate, formatDateTime } from "../../../../utils/dateutils";
import { useSelector } from "react-redux";
import { selectSystemsForCurrentBranch } from "../../../../core/data/redux/slice/systemsSlice";
import { selectCurrentSession } from "../../../../core/data/redux/slice/sessionsSlice";
import { selectUser } from "../../../../core/data/redux/slice/user";
import { selectCurrentBranch } from "../../../../core/data/redux/slice/branchesSlice";
import { campusBrandName, campusBranchLabel } from "../../../../utils/campusLogos";

interface RegistrationData extends TableData {
  registrationNumber: string;
  firstName: string;
  gender: string;
  status: string;
  createdAt: string;
  dateOfBirth: string;
  fatherEmail: string;
  fatherPhoneNumber: string;
  _id: string;
  lastName: string;
  studentPicture: string;
  academicYear: string;
  fatherName: string;
  interviewTime: string;
  interviewDate: string;
}

type paginationDataType = {
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  total: number;
  totalPages: number;
};

const RegistrationList = () => {
  const componentRef = useRef<HTMLDivElement>(null);
  const systems = useSelector(selectSystemsForCurrentBranch);
  const currentSession = useSelector(selectCurrentSession);
  const currentBranch = useSelector(selectCurrentBranch);
  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const [data, setData] = useState<RegistrationData[]>([]);
  const user = useSelector(selectUser);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ limit: 10, page: 1 });
  const [paginationData, setPaginationData] = useState<paginationDataType>();
  const [searchText, setSearchText] = useState("");
  const [classes, setAllClasses] = useState<Option[]>([]);
  const [classesLoading, setClassesLoading] = useState(false);
  const [selectedRegistration, setSelectedRegistration] =
    useState<RegistrationData | null>(null);
  const [filters, setFilters] = useState<{
    class?: Option[];
    gender?: Option;
    status?: Option;
    source?: Option;
  } | null>(null);

  const [appliedFilters, setAppliedFilters] = useState<{
    class?: string[];
    gender?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    system?: string;
    source?: string;
  } | null>({ system: systems[0]._id });

  const [sortBy, setSortBy] = useState(REGISTRATION_SORT_OPTIONS[0]);

  // Fetch registration data from API
  const fetchRegistrations = async () => {
    setLoading(true);
    try {
      const response = await getAllRegistration({
        ...pagination,
        ...appliedFilters,
        ...sortBy.value,
        class: appliedFilters?.class?.join(","),
        searchText,
        session: currentSession?._id,
      });
      setData(response.registrations);
      setPaginationData(response.pagination);
    } catch (error) {
      console.error("Failed to fetch registrations:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdmitCardClick = (record: RegistrationData) => {
    setSelectedRegistration(record);
  };

  const fetchClasses = async () => {
    setClassesLoading(true);
    try {
      const response = await getAllClasses();
      const formattedClasses = response.classes.map((classItem: Class) => ({
        label: classItem.name,
        value: classItem._id,
      }));
      setAllClasses(formattedClasses);
    } catch (error) {
      console.error("Error fetching classes:", error);
    } finally {
      setClassesLoading(false);
    }
  };

  useEffect(() => {
    fetchRegistrations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, searchText, appliedFilters, sortBy, currentSession?._id]);

  // Reset to page 1 when header session changes so list reflects new session filter
  useEffect(() => {
    setPagination((p) => ({ ...p, page: 1 }));
  }, [currentSession?._id]);

  useEffect(() => {
    fetchClasses();
  }, []);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
    const classIds = filters?.class?.map((cls) => cls.value) || [];
    setAppliedFilters((prev) => ({
      ...prev,
      class: classIds,
      gender: (filters?.gender?.value as string) || undefined,
      status: (filters?.status?.value as string) || undefined,
      source: (filters?.source?.value as string) || undefined,
    }));
  };

  const handlePrint = useReactToPrint({ contentRef: componentRef });

  const columns = [
    {
      title: "Registration No",
      dataIndex: "registrationNumber",
      render: (text: string, record: RegistrationData) => (
        <Link
          to={routes.registrationFormDetail}
          state={record}
          className="link-primary"
        >
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.AdmissionNo.length - b.AdmissionNo.length,
    },
    {
      title: "Full Name",
      dataIndex: "fullname",
      render: (_text: string, record: RegistrationData) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <ImageWithBasePath
              src={"assets/img/students/student-01.jpg"}
              fullSrc={record.studentPicture}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to={routes.registrationFormDetail}
                state={record}
              >{`${record.firstName} ${record.lastName}`}</Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.firstName.length - b.firstName.length,
    },
    {
      title: "Class",
      dataIndex: ["appliedClass", "name"],
      sorter: (a: TableData, b: TableData) =>
        a.appliedClass.name.length - b.appliedClass.name.length,
    },

    {
      title: "Gender",
      dataIndex: "gender",
      sorter: (a: TableData, b: TableData) => a.gender.length - b.gender.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: string) => {
        return (
          <>
            <span
              className={`badge d-inline-flex align-items-center ${
                status === "accepted"
                  ? "badge-soft-success"
                  : status === "rejected"
                  ? "badge-soft-danger"
                  : "badge-soft-warning"
              }`}
            >
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {status}
            </span>
          </>
        );
      },
      sorter: (a: TableData, b: TableData) => a.status.length - b.status.length,
    },
    {
      title: "Date/Time of Submission",
      dataIndex: "createdAt",
      sorter: (a: TableData, b: TableData) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      render: (createdAt: string) => formatDateTime(createdAt),
    },
    {
      title: "Date of Birth",
      dataIndex: "dateOfBirth",
      sorter: (a: TableData, b: TableData) =>
        new Date(a.dateOfBirth).getTime() - new Date(b.dateOfBirth).getTime(),
      render: (dateOfBirth: string) => formatDate(dateOfBirth),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "no-print",
      render: (_: any, record: RegistrationData) => (
        <>
          <div className="d-flex align-items-center">
            {/* <Link
              to="#"
              className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle  p-0 me-2"
            >
              <i className="ti ti-brand-hipchat" />
            </Link> */}
            <Link
              to={`tel:${record.fatherPhoneNumber}`}
              className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle  p-0 me-2"
            >
              <i className="ti ti-phone" />
            </Link>
            <Link
              to={`mailto:${record.fatherEmail}`}
              className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-3"
            >
              <i className="ti ti-mail" />
            </Link>
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add_fees_collect"
              className="btn btn-primary btn-sm fw-semibold me-2"
              onClick={() => handleAdmitCardClick(record)}
            >
              Admit Card
            </Link>
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-1">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to={routes.registrationFormDetail}
                    state={record}
                  >
                    <i className="ti ti-menu me-2" />
                    View Form
                  </Link>
                </li>
                <li>
                  <Link
                    className={`dropdown-item rounded-1 ${
                      !user.permissions?.includes("registration.edit") &&
                      user.permissions?.length
                        ? "not-allowed"
                        : ""
                    }`}
                    to={
                      user.permissions?.includes("registration.edit") ||
                      !user.permissions?.length
                        ? routes.addRegistrationForm
                        : "#"
                    }
                    state={
                      user.permissions?.includes("registration.edit") ||
                      !user.permissions?.length
                        ? record
                        : null
                    }
                    onClick={(e) => {
                      if (
                        !user.permissions?.includes("registration.edit") &&
                        user.permissions?.length
                      ) {
                        e.preventDefault();
                      }
                    }}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>

                <li>
                  <Link
                    className={`dropdown-item rounded-1 ${
                      !user.permissions?.includes("registration.delete") &&
                      user.permissions?.length
                        ? "not-allowed"
                        : record.status === "accepted"
                        ? "text-muted disabled-link"
                        : ""
                    }`}
                    to="#"
                    data-bs-toggle={
                      (user.permissions?.includes("registration.delete") ||
                        !user.permissions?.length) &&
                      record.status !== "accepted"
                        ? "modal"
                        : ""
                    }
                    data-bs-target={
                      (user.permissions?.includes("registration.delete") ||
                        !user.permissions?.length) &&
                      record.status !== "accepted"
                        ? "#delete-modal"
                        : ""
                    }
                    onClick={(e) => {
                      if (
                        !user.permissions?.includes("registration.delete") &&
                        user.permissions?.length
                      ) {
                        e.preventDefault();
                      } else if (record.status === "accepted") {
                        e.preventDefault();
                      } else {
                        setSelectedId(record._id);
                      }
                    }}
                    title={
                      record.status === "accepted"
                        ? "Cannot delete accepted registration"
                        : "Delete"
                    }
                    style={
                      record.status === "accepted"
                        ? { cursor: "not-allowed", opacity: 0.5 }
                        : {}
                    }
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  const handleChange = (page: number, pageSize: number) => {
    setPagination({ limit: pageSize, page: page });
  };

  const handleResetFilters = () => {
    setFilters({
      class: [],
      gender: { label: "Select", value: "" },
      status: { label: "Select", value: "" },
      source: { label: "Select", value: "" },
    });
    setAppliedFilters(null);
  };

  // const handleDateSelect = ({
  //   startDate,
  //   endDate,
  // }: {
  //   startDate: string;
  //   endDate: string;
  // }) => {
  //   setAppliedFilters((prev) => ({
  //     ...prev,
  //     startDate,
  //     endDate,
  //   }));
  // };

  const handleSortSelect = (item: {
    label: string;
    value: {
      sortBy: string;
      sortOrder: string;
    };
  }) => {
    setSortBy(item);
  };

  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      data.map((item) => ({
        "Registration Number": item.registrationNumber,
        "Student Name": `${item.firstName} ${item.lastName}`,
        "Applied Class": item.appliedClass.name,
        Gender: item.gender,
        Status: item.status,
        "Applied On": formatDateTime(item.createdAt),
        "Father Email": item.fatherEmail,
        "Father Phone": item.fatherPhoneNumber,
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Registrations");
    XLSX.writeFile(wb, "registrations.xlsx");
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Registrations</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Registrations</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Registration Form List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption
                onRefresh={fetchRegistrations}
                onExportPdf={handlePrint}
                onExportExcel={handleExportExcel}
              />
              <div className="mb-2">
                <Link
                  to={routes.addRegistrationForm}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  New Registration
                </Link>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Registration Forms</h4>
              <div className="d-flex align-items-center flex-wrap">
                {currentSession && (
                  <div className="mb-3 me-2">
                    <span className="badge badge-soft-info d-inline-flex align-items-center px-3 py-2">
                      <i className="ti ti-calendar-due me-1" />
                      Session: {currentSession.title}
                    </span>
                  </div>
                )}
                <div className="mb-3 me-2">
                  <CommonSelect
                    className="select"
                    options={systems}
                    value={systems.find(
                      (item) => item._id === appliedFilters?.system
                    )}
                    getOptionValue={(item) => item._id}
                    getOptionLabel={(item) => item.name}
                    onChange={(systemItem) =>
                      setAppliedFilters((prev) => ({
                        ...prev,
                        system: systemItem?._id,
                      }))
                    }
                  />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 pb-0 border-bottom">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              {classesLoading ? (
                                <div> Loading classes... </div>
                              ) : (
                                <MultiSelectSection
                                  options={classes}
                                  value={filters?.class || []}
                                  onChange={(selectedOptions: Option[]) => {
                                    setFilters((prev) => ({
                                      ...prev,
                                      class: selectedOptions,
                                    }));
                                  }}
                                  placeholder="Select classes..."
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Gender</label>
                              <CommonSelect
                                className="select"
                                options={gender}
                                value={filters?.gender}
                                onChange={(genderItem) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    gender: genderItem as Option,
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Fee Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                value={filters?.status}
                                onChange={(statusItem) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    status: statusItem as Option,
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Source</label>
                              <CommonSelect
                                className="select"
                                options={[
                                  { label: "Online", value: "online" },
                                  { label: "In-Person", value: "in-person" },
                                ]}
                                value={filters?.source}
                                onChange={(sourceItem) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    source: sourceItem as Option,
                                  }))
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <div
                          className="btn btn-light me-3"
                          onClick={handleResetFilters}
                        >
                          Reset
                        </div>
                        <div
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                  <Link
                    to={routes.registrationFormList}
                    className="active btn btn-icon btn-sm me-1 primary-hover"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={routes.registrationFormGrid}
                    className="btn btn-icon btn-sm bg-light primary-hover"
                  >
                    <i className="ti ti-grid-dots" />
                  </Link>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by {sortBy.label}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    {REGISTRATION_SORT_OPTIONS.map((item, index) => (
                      <li key={index}>
                        <div
                          className={`dropdown-item rounded-1 ${
                            item.label === sortBy.label ? "active" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSortSelect(item)}
                        >
                          {item.label}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="card-body p-0 py-3 printable-content"
              ref={componentRef}
            >
              <div className="print-only-header">
                <div className="school-brand">
                  <img src={currentBranch?.blackLogoUrl || "/assets/img/icons/logo.png"} alt={campusBrandName(currentBranch)} />
                  <strong>{campusBrandName(currentBranch)}{campusBranchLabel(currentBranch) ? ` - ${campusBranchLabel(currentBranch)}` : ""}</strong>
                </div>
                <div className="report-title">Registration List</div>
                <div className="print-date">{new Date().toLocaleDateString("en-GB")}</div>
              </div>
              <Table
                setSearchText={setSearchText}
                dataSource={data}
                columns={columns}
                loading={loading}
                pagination={{ ...paginationData, onChange: handleChange }}
              />
            </div>
          </div>
        </div>
      </div>
      <RegistrationModals
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        fetchData={fetchRegistrations}
        registrationData={selectedRegistration}
        isFromDetails={false}
      />
    </>
  );
};

export default RegistrationList;
